import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../../app/applicationSlice'
import { RootThunkApi } from '../../../app/store'
import {
  PDRecordListParams,
  getPDRecordList,
  getPDRecordDetail,
  SubmitParams,
  getPDRecordSubmit,
  getPDRecordExport,
  getRemove,
  getExamine
} from '../../../services/pharmaceuticalDestructionRecord'

// 列表
export const getPDRecordListAsync = createAsyncThunk<
  void,
  PDRecordListParams,
  RootThunkApi<void>
>('PDRecord/getPDRecordListAsync', async (params, api) => {
  return sendAsync(getPDRecordList(params), api)
})

// 详情
export const getPDRecordDetailAsync = createAsyncThunk<
  void,
  any,
  RootThunkApi<void>
>('PDRecord/getPDRecordDetailAsync', async (params, api) => {
  return sendAsync(getPDRecordDetail(params), api)
})

// 保存编辑
export const getPDRecordSubmitAsync = createAsyncThunk<
  void,
  SubmitParams,
  RootThunkApi<void>
>('PDRecord/getPDRecordSubmitAsync', async (params, api) => {
  return sendAsync(getPDRecordSubmit(params), api)
})

//导出
export const getPDRecordExportAsync = createAsyncThunk<
  void,
  PDRecordListParams,
  RootThunkApi
>('PDRecord/getPDRecordExportAsync ', async (params, api) => {
  return sendAsync(getPDRecordExport(params), api)
})

// 删除
export const getRemoveAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'PDRecord/getRemoveAsync',
  async (params, api) => {
    return sendAsync(getRemove(params), api)
  }
)

// 审核
export const getExamineAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'PDRecord/getExamineAsync',
  async (params, api) => {
    return sendAsync(getExamine(params), api)
  }
)